// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { resolve } from '../../../../init/store';

export class Controller {
    /** @ngInject */
    constructor(AccessRequestsService, ShowNoteModal, ConfirmDeleteModal, $state) {
        this.AccessRequestsService = AccessRequestsService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
    }

    $onInit() {
        resolve.hasRequests = this.requests.length > 0;
    }

    showNote(requestDto){
        this.ShowNoteModal('Note', requestDto.note);
    }

    deleteRequest(requestDto) {
        this.ConfirmDeleteModal('Are you sure you want to delete this request')
            .then(() => {
                this.AccessRequestsService.deleteRequestForCompany(this.companyId, requestDto.id)
                    .then(() => this.$state.reload('company.request-center'));
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/list/request-center-list.controller.js